module.exports = __webpack_public_path__ + "static/media/exclamation_mark_rectangle_blue.d88ffa36.svg";